import axios from 'axios';

const apiClient = axios.create({
  // Use proxy in development, environment variable in production
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_API_BASE_URL,
});

// Request interceptor to add authorization header if token exists
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('xToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default apiClient;
